import { create } from 'zustand';

export type ConfirmRequest = {
  title: string;
  content: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
};

export type ConfirmState = {
  isOpen: boolean;
  confirmRequest: ConfirmRequest;
};

export type ConfirmActions = {
  openConfirm: (request: ConfirmRequest) => void;
  closeConfirm: () => void;
};

export type ConfirmStore = ConfirmState & ConfirmActions;

export const useConfirmStore = create<ConfirmStore>((set) => ({
  // Initial state
  isOpen: false,
  confirmRequest: {
    title: '',
    content: '',
  },

  // Actions
  openConfirm: (request: ConfirmRequest) => {
    set({ confirmRequest: request, isOpen: true });
  },

  closeConfirm: () => {
    set({ isOpen: false });
  },
}));
